import React from 'react'

import classNames from 'classnames'
import PropTypes from 'prop-types'

import './Step.less'

const Step = ({selected, children}) => {
  let stepClass = classNames('nmc-progress-step', {
    'nmc-progress-step-selected': selected
  })

  return <div className={stepClass}>
    <div className='nmc-progress-step-label'>{children}</div>
    <div className='nmc-progress-step-bar' />
  </div>
}

Step.propTypes = {
  selected: PropTypes.bool
}

Step.defaultProps = {
  selected: false
}

export default Step



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/ProgressTracker/Step/index.js